import React from 'react';

import NHFetch from '../../utils/NHFetch';


export default class Footer extends React.Component {

    constructor (props) {
        super(props)
        
        this.state = {
            copyright: ''
        }
    }

    componentDidMount() {
        NHFetch('api/zhxg-yxwz/getCopyrightInformation', 'GET').then(res => {
            if (res&&res.data) {
                this.setState({copyright: res.data});
            }
        });
    }

    render() {

        const {copyright} = this.state;

        return(
            <div style={{fontSize:'12px',minWidth: '1180px',color: '#fff',backgroundColor:'#05a4ff',textAlign:'center',lineHeight:'50px'}}>
               {copyright}
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./plugins/footer/index.js